/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Recent_SalesInputs */

const fr_no_recent_sales = /** @type {(inputs: No_Recent_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune vente récente`)
};

/**

* @param {No_Recent_SalesInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const no_recent_sales = /** @type {((inputs?: No_Recent_SalesInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Recent_SalesInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_no_recent_sales(inputs)
});